import { useSyncExternalStore } from 'react'

const emptySubscribe = () => () => {/* empty */}

const getSnapshot = (): boolean => true
const getServerSnapshot = (): boolean => false

const useIsHydrated = (): boolean => useSyncExternalStore(emptySubscribe, getSnapshot, getServerSnapshot)

export default useIsHydrated
